class AccessProfileModel {
  public readonly uid: string;
  public name: string;
  public permissions: string[];
  public createdAt: Date;
  public modifiedAt: Date;
  public quantityUsers: number = 0;

  constructor(
    uid: string,
    name: string = "",
    permissions: string[] = [],
    createdAt: Date = new Date(),
    modifiedAt: Date = new Date()
  ) {
    this.uid = uid;
    this.name = name;
    this.permissions = permissions;
    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
  }

  setQuantityUsers(quantity: number) {
    this.quantityUsers = quantity;
  }

  isAdmin() {
    return this.name === "Administrador";
  }

  toSave() {
    return {
      name: this.name,
      permissions: this.permissions,
      createdAt: this.createdAt,
      modifiedAt: this.modifiedAt,
    };
  }

  static create(
    uid: string,
    data: Partial<AccessProfileModel>
  ): AccessProfileModel {
    return new AccessProfileModel(
      uid,
      data.name,
      data.permissions,
      data.createdAt,
      data.modifiedAt
    );
  }
}

export default AccessProfileModel;
